import React, { Fragment, useState } from 'react';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CardSection from 'components/sales/cardSection/cardSection';
import ModalPop from 'components/sales/modal/modal';
import './siteStageCard.css';
const SiteStageCard = ({
  data,
  siteDetails,
  history,
  siteId,
  isVendorAllocated,
  count,
  locationCheck,
  match,
  infraId,
  isCarnivalActive,
  baseUrl,
  isPoCreated,
  isDashboardTraining = false
}) => {
  // console.log("QAQAQ",data)
  const [isShowModal, setIsShowModal] = useState(false);
  const [isNotMatchModal, setNotMatchModal] = useState(false);
  const [isModalLocation, setIsModalLocation] = useState(false);
  const handleModalHideLocation = () => setIsModalLocation(false);
  const [isCarnivalModal, setIsCarnivalModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Location check is fetched once in siteStages parent — not per stage card.

  const locationVaidate = (name, islocationValid, stageId, status) => {
    // Not Started
    if (stageId !== 3 && stageId !== 6 && stageId !== 11 && stageId !== 12 && stageId !== 9) {
      if(status ==='Not Started'){
        history.push({
          pathname: `/dashboard/site_inspection_material/${siteId}/stage/${stageId}`,
          state: {
            status,
            islocationValid:
              siteDetails &&
              siteDetails.length > 0 &&
              siteDetails[0].is_location_validate &&
              islocationValid
                ? true
                : false,
          },
        });
      }else{
        history.push({
          pathname: `/dashboard/gate/${name
            .toLowerCase()
            .replace(' ', '-')}/${siteId}/stage/${stageId}`,
          state: {
            status,
            islocationValid:
              siteDetails &&
              siteDetails.length > 0 &&
              siteDetails[0].is_location_validate &&
              islocationValid
                ? true
                : false,
          },
        });
      }
      
    } else if(stageId === 9) {
      if(islocationValid) {
        if (locationCheck?.status === 2) {
          history.push({
            pathname: `/dashboard/pos-shipment/${siteId}/stage/${stageId}`,
            state: {
              status,
              islocationValid:
                siteDetails &&
                siteDetails.length > 0 &&
                siteDetails[0].is_location_validate &&
                islocationValid
                  ? true
                  : false,
            },
          });
        } else if (locationCheck?.status === 1) {
            setIsModalLocation(true);
          } else if (locationCheck?.status === 3) {
            isShowModal(true);
          } else if(locationCheck?.status === 0) {
            setNotMatchModal(true)
          }
        }
    } else if(stageId === 6){
      if(islocationValid) {
      if (locationCheck?.status === 2) {
        history.push({
          pathname: `/dashboard/tag-delivery/${siteId}/stage/${stageId}`,
          state: {
            status,
            islocationValid:
              siteDetails &&
              siteDetails.length > 0 &&
              siteDetails[0].is_location_validate &&
              islocationValid
                ? true
                : false,
          },
        });
      } else if (locationCheck?.status === 1) {
          setIsModalLocation(true);
        } else if (locationCheck?.status === 3) {
          isShowModal(true);
        } else if(locationCheck?.status === 0) {
          setNotMatchModal(true)
        }
      }
        else{
          history.push({
            pathname: `/dashboard/material-delivery/${siteId}/stage/${stageId}`,
            state: {
              status,
              islocationValid:
                siteDetails &&
                siteDetails.length > 0 &&
                siteDetails[0].is_location_validate &&
                islocationValid
                  ? true
                  : false,
            },
          });
        }
     
    } else if(stageId === 11 || stageId === 12) {
      if(islocationValid) {
        if (locationCheck?.status === 2) {
          history.push({
            pathname: (stageId === 11) ? `/dashboard/dashboard-training/${siteId}/stage/${stageId}/${match.params.manageId}` : `/dashboard/carnival/carnival-conduct/${siteId}/stage/${stageId}/${match.params.manageId}`,
            state: {
              status,
              islocationValid:
                siteDetails &&
                siteDetails.length > 0 &&
                siteDetails[0].is_location_validate &&
                islocationValid
                  ? true
                  : false,
            },
          });
        } else if (locationCheck?.status === 1) {
            setIsModalLocation(true);
          } else if (locationCheck?.status === 3) {
            isShowModal(true);
          } else if(locationCheck?.status === 0) {
            setNotMatchModal(true)
          }
      }
    }
    else{

      if(islocationValid) {
        if (locationCheck?.status === 2) {
          history.push({
            pathname: `/dashboard/material-delivery/${siteId}/stage/${stageId}`,
            state: {
              status,
              islocationValid:
                siteDetails &&
                siteDetails.length > 0 &&
                siteDetails[0].is_location_validate &&
                islocationValid
                  ? true
                  : false,
            },
          });
        } else if (locationCheck?.status === 1) {
            setIsModalLocation(true);
          } else if (locationCheck?.status === 3) {
            isShowModal(true);
          } else if(locationCheck?.status === 0) {
            setNotMatchModal(true)
          }
      } else {
      history.push({
        pathname: `/dashboard/material-delivery/${siteId}/stage/${stageId}`,
        state: {
          status,
          islocationValid:
            siteDetails &&
            siteDetails.length > 0 &&
            siteDetails[0].is_location_validate &&
            islocationValid
              ? true
              : false,
        },
      });
    }
    }
  };

  return (
    <CardSection title={data.name} status={data.statusName} invoice_creation={data.invoice_create} size={data.stage_id}>
      {/* {console.log(data.stage_id)} */}
      <div className="details-listing">
        <div className="details-list">
          <strong className="data-title">
            {localization.stageExpectedClosure}
          </strong>
          <span className="data-details">{data.expected_closure_date}</span>
        </div>

        {data.actual_closure_date !== null && (
          <div className="details-list">
            <strong className="data-title">
              {localization.actualClosureDate}
            </strong>
            <span className="data-details" >{data.actual_closure_date}</span>
          </div>
        )}
        {(data.status === 2 || data.status === 3) && (

          (siteDetails && siteDetails[0].status !== 2 && siteDetails[0].status !== 5 && siteDetails[0].status !== 6 && siteDetails[0].status !== 14 && siteDetails[0].status !== 15 ) ? (
            <>
            {(data.stage_id === 12 && isCarnivalActive === null) ? 
            <div className='row form-btn'>
            <div className="col-8" >
              <a href={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`} className="btn btn-sm btn-transparent">
                {`Carnival/Helpdesk List`}
              </a>
              </div>
            </div>
            :
            <>
            {data.stage_id === 5 &&
            (
              (siteDetails && siteDetails[0]?.asset_mapping_complete == 0) ||
              isPoCreated === 0 ||
              isDashboardTraining === true
            ) ? (
              <>
                {siteDetails && siteDetails[0]?.asset_mapping_complete == 0 && (
                  <div
                    style={{
                      minHeight: '10px',
                      marginBottom: '10px',
                      color: 'red'
                    }}
                  >
                    Please complete asset mapping
                  </div>
                )}

                {isPoCreated === 0 && (
                  <div
                    style={{
                      minHeight: '10px',
                      marginBottom: '10px',
                      color: 'red'
                    }}
                  >
                    Please create PO for this Site
                  </div>
                )}

                {isDashboardTraining === true && (
                  <div
                    style={{
                      minHeight: '10px',
                      marginBottom: '40px',
                      color: 'red'
                    }}
                  >
                    Please start dashboard training
                  </div>
                )}
              </>
            ) : (
              <div className="form-btn">
                {data.name === 'Carnival' && (
                  <div className="form-btn col-8">
                    <a href={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`} className="btn btn-transparent">
                      {`Carnival/Helpdesk List`}
                    </a>
                </div>
                )}
                <Button
                  className="btn btn-transparent"
                  onClick={() => {
                    count !== 0 && data.stage_id !== 11 && data.stage_id !== 12 && data.stage_id !== 6 && data.stage_id !== 7 && isVendorAllocated === 0 && data.status === 2
                      ? setIsModalOpen(true)
                      : locationVaidate(
                          data.name,
                          data.is_location_validate,
                          data.stage_id,
                          data.statusName
                        );
                    if (data.stage_id === 12) {
                      setIsCarnivalModal(true);
                    }
                  }}
                >
                  {localization.manageStage}
                </Button>
              </div>
            )}
              </>
            }
            </>

          ) : 
          (data.stage_id === 12 && isCarnivalActive === null) ? 
            <div className="form-btn col-8">
              <a href={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`} className="btn btn-transparent">
                {`Carnival/Helpdesk List`}
              </a>
            </div>
          : 
          ((data && data.stage_id === 6 && data.status === 3) ?

              <div className="form-btn">
                {data.name === 'Carnival' && (
                  <div className="form-btn col-8">
                    <a href={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`} className="btn btn-transparent">
                      {`Carnival/Helpdesk List`}
                    </a>
                </div>
            )}
              <Button className="btn btn-transparent"
              >
                {data.statusName} data.stage_id
              </Button>
            </div>
            : 
            ((siteDetails && (siteDetails[0].status === 5 || siteDetails[0].status === 6 || siteDetails[0].status === 14 || siteDetails[0].status === 15) ) ? 
            <div className="form-btn">
            {data.name === 'Carnival' && (
              <div className="form-btn col-8">
                <a href={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`} className="btn btn-transparent">
                  {`Carnival/Helpdesk List`}
                </a>
            </div>
            )}
            <Button className="btn btn-transparent" disabled
            >
              {data.statusName}
            </Button>
          </div>
            :
            <div className="form-btn">
              {data.name === 'Carnival' && (
              <div className="form-btn col-8">
                <a href={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`} className="btn btn-transparent">
                  {`Carnival/Helpdesk List`}
                </a>
            </div>
            )}
                <Button className="btn btn-transparent"
                onClick={() => {
                          count !== 0 && data.stage_id !== 11 && data.stage_id !== 12 && isVendorAllocated === 0 && data.status === 2
                            ? setIsModalOpen(true)
                            : locationVaidate(
                                data.name,
                                data.is_location_validate,
                                data.stage_id,
                                data.statusName
                              );
                        }}>
                  {data.statusName}
                </Button>
          </div>
            )
            
            )
           )}
       
        

        {data.status === 1 && (
          <div className="form-btn form-btn1 form-btn_N">
            {(data.stage_id === 1) ? 
             <Button className="btn btn-transparent" 
             onClick={() => {
              count !== 0 && data.stage_id !== 11 && data.stage_id !== 12 && isVendorAllocated === 0 && data.status === 2
                ? setIsModalOpen(true)
                : locationVaidate(
                    data.name,
                    data.is_location_validate,
                    data.stage_id,
                    data.statusName
                  );
            }}
             >
              Material Mapping
             </Button>
            :
            <Button className="btn btn-transparent" disabled>
             {data.statusName}
            </Button>
            }
           
          </div>
        )}
      </div>
      <ModalPop
        title={'Manage Stage'}
        show={isModalOpen}
        handleModalHide={() => setIsModalOpen(false)}
      >
        No vendor allocated, please allocate a vendor.
      </ModalPop>

      <ModalPop
        title={localization.note}
        show={isModalLocation}
        handleModalHide={handleModalHideLocation}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5 style={{ color: "red" }}>
            {localization.locationApprovalPending}
          </h5>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.note}
        show={isNotMatchModal}
        handleModalHide={() => {
          setNotMatchModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5 style={{ color: "red" }}>
            {localization.locationDoesNotMatch}
          </h5>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.note}
        show={isCarnivalModal}
        handleModalHide={() => {
          setIsCarnivalModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="form-btn col-8">
              <a href={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`} className="btn btn-transparent">
                {`Carnival/Helpdesk List`}
              </a>
          </div>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.note}
        show={isShowModal}
        handleModalHide={() => {
          setIsShowModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5 style={{ color: "red" }}>
            {localization.locationApprovalRejected}
          </h5>
        </div>
      </ModalPop>
    </CardSection>
  );
};
export default SiteStageCard;
